// extracted by mini-css-extract-plugin
module.exports = {"layout":"scroll-ticker_layout__9j6Ec","content":"scroll-ticker_content__lv4xt"};